import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';

const UrlAddForm = ({ onAdd, isAdding = false, disabled = false }) => {
  const [value, setValue] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    await onAdd(trimmed);
    setValue('');
  };

  return (
    <Box component='form' onSubmit={handleSubmit} display='flex' gap={1} mb={1.5}>
      <TextField
        size='small'
        fullWidth
        placeholder='Paste or type a URL here...'
        value={value}
        disabled={disabled || isAdding}
        onChange={(event) => setValue(event.target.value)}
      />
      <Button
        type='submit'
        variant='contained'
        disabled={disabled || isAdding || !value.trim()}
        sx={{ textTransform: 'none', flexShrink: 0, minWidth: 72 }}
      >
        Add
      </Button>
    </Box>
  );
};

export default UrlAddForm;
